import { createContext, useContext } from 'react'
import PropTypes from 'prop-types'

const PlatformVersionContext = createContext('')

export const PlatformVersionProvider = ({ children, version }) => (
  <PlatformVersionContext.Provider value={version || ''}>
    {children}
  </PlatformVersionContext.Provider>
)

PlatformVersionProvider.propTypes = {
  children: PropTypes.node.isRequired,
  version: PropTypes.string
}

PlatformVersionProvider.defaultProps = {
  version: ''
}

export const usePlatformVersion = () => useContext(PlatformVersionContext)
